/** Keep only the latest mark of each name so repeated scene transitions cannot grow the timeline indefinitely. */
export function markPerformance(name: string) {
  performance.clearMarks(name);
  performance.mark(name);
}
